import React from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles";

// Un SVG: el degradado lleva los valores del tema, no sus nombres
function GradientCircularProgress() {
  const { palette } = useTheme();
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="loading" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={palette.secondary.main} />
            <stop offset="100%" stopColor={palette.primary.main} />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress size={50} sx={{ "svg circle": { stroke: "url(#loading)" } }} />
    </React.Fragment>
  );
}

export const SimpleLoading = ({ open }) => (
  <Backdrop
    sx={{ 
      color: "white", 
      zIndex: (theme) => theme.zIndex.drawer + 1 }
    }
    open={open}
  >
    <Box     
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <GradientCircularProgress />
      <Typography variant="h6" mt={2}>
        Espere...
      </Typography>
    </Box>
  </Backdrop>
);

export const Loading = () => (
  <Box
    className="loading-content"
    width="100%"
    my={5}
  >
    <GradientCircularProgress />
    <Typography variant="h6" mt={2} sx={{ color: "primary.main" }}>
      Cargando...
    </Typography>
  </Box>
)
